import './style.css';
import 'flowbite/dist/flowbite.js';
import './sidebar';
import './charts';
import './dark-mode';
import './pagination';
import './user-role';
import './logout';
import './handlerow';
import './table_clickable_producto_varios';
